// @ts-nocheck

import { Swiper } from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

new Swiper("#banner-slider .swiper", {
    modules: [Autoplay, Pagination],
    spaceBetween: 10,
    centeredSlides: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    loop: true,
    pagination: {
        el: "#banner-slider .swiper-pagination",
        clickable: true,
    },
});
